import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '../ui';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Attempt {
  id: number;
  score: number;
  passed: boolean;
  totalQuestions: number;
  correctAnswers: number;
  completedAt: string;
}

interface QuizAttemptHistoryProps {
  attempts: Attempt[];
}

export default function QuizAttemptHistory({ attempts }: QuizAttemptHistoryProps) {
  if (attempts.length === 0) return null;

  return (
    <Accordion sx={{ mt: 2 }} defaultExpanded={false}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body2" fontWeight={600}>
          Previous Attempts ({attempts.length})
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Score</TableCell>
                <TableCell>Result</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {attempts.map((attempt, index) => (
                <TableRow key={attempt.id}>
                  <TableCell>{attempts.length - index}</TableCell>
                  <TableCell>
                    {new Date(attempt.completedAt).toLocaleDateString(undefined, {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </TableCell>
                  <TableCell>
                    {Math.round(attempt.score)}% ({attempt.correctAnswers}/{attempt.totalQuestions})
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={attempt.passed ? 'Passed' : 'Failed'}
                      color={attempt.passed ? 'success' : 'error'}
                      size="small"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
}
